import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('authorise_the_payment'),
    description: defineMessage('enter_the_digit_authent_port_articlesupportlink'),
    codeFieldTitle: defineMessage('enter_the_authenticator_code'),
    wrongCodeErrorText: defineMessage('wrong_code'),
    userCodePlaceholder: defineMessage('enter_the_authenticator_code_2'),
    confirmButton: defineMessage('confirm'),
};
